import React from "react";
import { Trans } from "@lingui/macro";
import { formatAmount } from "pages/Event/utils/formatAmount";

type Props = React.ComponentProps<"input"> & {
  amount?: string;
  onChangeAmount?: (amount: string) => void;
  plpBalance: string;
};

const ToInput = ({ amount, plpBalance, onChangeAmount, ...restProps }: Props) => {
  return (
    <div className="flex flex-col items-stretch gap-2 px-6 py-4 border rounded-sm bg-background-3">
      <div className="flex justify-between gap-2 text-inactive text-[1.2rem] leading-[1.5]">
        <p>
          <Trans>Receive: {formatAmount(amount || "0", { trimMantissa: false })} PLP</Trans>
        </p>

        <p>
          {plpBalance ? (
            <Trans>Balance: {formatAmount(plpBalance, { mantissa: 4, trimMantissa: false })} </Trans>
          ) : (
            <br />
          )}{" "}
          PLP
        </p>
      </div>
      <div className="flex justify-between gap-2 text-inactive text-[1.2rem] leading-[1.5]"></div>

      <div className="flex items-center gap-2">
        <input
          type="number"
          min="0"
          placeholder="0.0"
          className="text-[1.8rem] leading-[1.5] placeholder:text-inactive flex-1 disabled:text-inactive"
          {...restProps}
          value={amount}
          onChange={(e) => onChangeAmount?.(e.target.value)}
        />

        <p className="text-[1.2rem] leading-[2.4rem]">PLP</p>
      </div>
    </div>
  );
};

export default React.memo(ToInput);
